/* eslint-disable no-unused-vars */
import Vue from "vue";
import Router from "vue-router";

import Meta from "vue-meta";
import axios from "axios";
import NProgress from 'nprogress';



Vue.use(Router);
Vue.use(Meta);

import Home from "./views/home.vue";
import Aftersales from "./views/aftersales.vue";
import About from "./views/about.vue";
import Contact from "./views/contact.vue";
import Commercial from "./views/mercedes/commercial";
import CommercialDetails from "./views/mercedes/commercialdetails";
import PassengerDetails from "./views/mercedes/passengerdetails";

import Product from "./views/mercedes/product";
import Pegeout from "./views/pageout/index";
import PeugeoutDetails from "./views/pageout/peugeotdetails";
import PeugeoutComDetails from "./views/pageout/peugeot_comdetails";
import Pproduct from "./views/pageout/product";
import Promotion from "./views/promotion";
import Privacy from "./views/Privacy";
import Terms from "./views/Terms";
import Milestones from "./views/Milestone";
import CSR from "./views/CSR";
import Awards from "./views/Awards";
import Citreon from "./views/citreon";
import Book from "./views/book";
import ArticleSearch from "./views/blog/ArticleSearch";
import Posts from "./views/blog/Posts";
import Post from "./views/blog/Post";







const router = new Router({
  mode: "history",
  routes: [
    { path: "/", name: "home", component: Home },
    { path: "/about", name: "about", component: About },
    { path: "/aftersales", name: "aftersales", component: Aftersales },
    { path: "/privacy", name: "privacy", component: Privacy },
    { path: "/contact", name: "contact", component: Contact },
    { path: "/book", name: "book", component: Book },
    
    { path: "/mercedes/commercial", name: "commercial", component: Commercial },
    { path: "/commercial/:producturl/:mask", name: "commercialdetails", component: CommercialDetails },
    { path: "/passenger/:producturl/:mask", name: "passengerdetails", component: PassengerDetails },
    { path: "/peugeotdetails/:producturl/:mask", name: "peugeotdetails", component: PeugeoutDetails },
    { path: "/peugeotcomdetails/:producturl/:mask", name: "peugeotcomdetails", component: PeugeoutComDetails },

  
    { path: "/mercedes/passenger", name: "product", component: Product },
    { path: "/awards", name: "awards", component: Awards },
    // { path: "/mercedescommercial/:mask", name: "product", component: MProducts },
    // { path: "/productdetails/:mask", name: "productdetails", component: ProductDetails },
    { path: "/peugeot", name: "pegeout", component: Pegeout },
    { path: "/peugeot/:mask", name: "pegeout_product", component: Pproduct },
    { path: "/promotion", name: "promotion", component: Promotion },
    { path: "/blog", name: "posts", component: Posts },
    { path: "/blog/:blogdash/:blogmask", name: "post", component: Post },
    {
      path: "/blogsearch/:articlesearch",
      name: "blogsearch",
      component: ArticleSearch
    },
    
    { path: "/terms", name: "terms", component: Terms },
    { path: "/milestones", name: "milestone", component: Milestones },
    { path: "/csr", name: "csr", component: CSR },
 
   
    {
      path: "/citroen",
      name: "citreon",
      component: Citreon
    },

   

    { path: "/*", name: "error404", component: Home }
  ],
  linkExactActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    //savedPosition
    return { x: 0, y: 0 };
  }
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
      // Start the route progress bar.
      NProgress.configure({ showSpinner: false }).start();
      // NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})
export default router;
